import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import {
  signalGradients,
  signalSurfaces,
  signalSurfacesLight,
} from '@/theme/foundations/tokens';

interface ProgressTrackProps {
  /** Completion 0..100. */
  value: number;
  /** Track thickness in px. */
  height?: number;
  /** Fill color. Defaults to the solid accent-bar token. */
  fill?: string;
  /** Track color. Defaults to the dark-surface track token. */
  track?: string;
  light?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * Transfer and storage meter. Both ends are pill-radiused so a 2% fill still
 * reads as a rounded bar rather than a sliver.
 */
export const ProgressTrack: React.FC<ProgressTrackProps> = ({
  value,
  height = 5,
  fill = signalGradients.accentBar,
  track,
  light = false,
  sx,
}) => (
  <Box
    role="progressbar"
    aria-valuenow={Math.round(value)}
    aria-valuemin={0}
    aria-valuemax={100}
    sx={{
      height,
      borderRadius: '999px',
      background:
        track ?? (light ? signalSurfacesLight.track : signalSurfaces.track),
      overflow: 'hidden',
      ...sx,
    }}
  >
    <Box
      sx={{
        width: `${Math.min(100, Math.max(0, value))}%`,
        height: '100%',
        borderRadius: '999px',
        background: fill,
      }}
    />
  </Box>
);

export default ProgressTrack;
